import type { IconData } from '@stacksjs/iconify-core'

export const otherUiMinimize: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 0H3v6h3V3h7v7h-3v3h6z\"/><path fill=\"currentColor\" d=\"M8 8H0v8h8z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiMinimize
